var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 213,
    viewBox: "0 0 430 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7891 132.2H37.9891L78.7891 62V132.2ZM116.889 206V162.5H139.389V132.2H116.889V6.79999H73.0891L0.489063 128.6V162.5H77.8891V206H116.889ZM216.065 181.4C197.165 181.4 187.565 161.6 187.565 106.1C187.565 51.2 197.165 31.4 216.065 31.4C234.965 31.4 244.265 51.5 244.265 106.7C244.265 161 234.965 181.4 216.065 181.4ZM214.865 212.9C257.765 212.9 283.865 179 283.865 104.9C283.865 30.8 257.765 0.199985 214.865 0.199985C171.965 0.199985 147.065 30.8 147.065 105.5C147.065 180.5 171.965 212.9 214.865 212.9ZM368.535 132.2H327.735L368.535 62V132.2ZM406.635 206V162.5H429.135V132.2H406.635V6.79999H362.835L290.235 128.6V162.5H367.635V206H406.635Z",
    fill: "#c2dcf7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.000b2425e5440f9af5dbc2a6784f95ad.svg";
export { ForwardRef as ReactComponent };